import CascadePanels from './CascadePanels';

export default CascadePanels;
